import { render } from "./KSSelect.vue?vue&type=template&id=611139fc"
import script from "./KSSelect.vue?vue&type=script&lang=js"
export * from "./KSSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__